export const MOBILE_WIDTH_QUERY = '(max-width: 1200px)';
export const MOBILE_TOUCH_LANDSCAPE_QUERY =
  '(max-height: 499px) and (hover: none) and (pointer: coarse)';
export const MOBILE_LAYOUT_QUERIES = [MOBILE_WIDTH_QUERY, MOBILE_TOUCH_LANDSCAPE_QUERY];
export const MOBILE_PORTRAIT_QUERY = `${MOBILE_WIDTH_QUERY} and (orientation: portrait)`;
